export const vehicleInitialState = {
    vehicles:[]
}